import "core-js/modules/es.array.includes.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    staticClass: "crm-page-header"
  }, [_c('div', [_c('h2', {
    staticClass: "font-weight-bolder mb-1"
  }, [_vm._v("Relatórios CRM")]), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v(" " + _vm._s(_vm.periodoLabel) + " · gráficos, consultas operacionais e agenda CRM ")])]), _c('button', {
    staticClass: "btn btn-light-primary btn-sm",
    attrs: {
      "type": "button",
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.aplicarFiltros
    }
  }, [_vm._v(" Atualizar ")])]), _c('div', {
    staticClass: "card card-custom gutter-b"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "crm-report-tabs"
  }, _vm._l(_vm.reportTabs, function (tab) {
    return _c('button', {
      key: tab.key,
      staticClass: "btn btn-sm",
      class: _vm.activeReport === tab.key ? 'btn-dark' : 'btn-light',
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.selectReport(tab.key);
        }
      }
    }, [_vm._v(" " + _vm._s(tab.label) + " ")]);
  }), 0), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "4",
      "lg": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Data inicial"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date"
    },
    model: {
      value: _vm.filtros.data_inicio,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "data_inicio", $$v);
      },
      expression: "filtros.data_inicio"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4",
      "lg": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Data final"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date"
    },
    model: {
      value: _vm.filtros.data_fim,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "data_fim", $$v);
      },
      expression: "filtros.data_fim"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4",
      "lg": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Responsável"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.usuarioOptions
    },
    model: {
      value: _vm.filtros.id_usuario,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "id_usuario", $$v);
      },
      expression: "filtros.id_usuario"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4",
      "lg": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Status"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.statusOptions
    },
    model: {
      value: _vm.filtros.status,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "status", $$v);
      },
      expression: "filtros.status"
    }
  })], 1)], 1), _vm.activeReport !== 'resumo' ? _c('b-col', {
    attrs: {
      "md": "8",
      "lg": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Busca"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Nome, telefone, título ou descrição"
    },
    model: {
      value: _vm.filtros.busca,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "busca", $$v);
      },
      expression: "filtros.busca"
    }
  })], 1)], 1) : _vm._e()], 1), ['resumo', 'oportunidades'].includes(_vm.activeReport) ? _c('b-row', [_c('b-col', {
    attrs: {
      "md": "4",
      "lg": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Funil"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.funilOptions
    },
    model: {
      value: _vm.filtros.id_crm_funil,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "id_crm_funil", $$v);
      },
      expression: "filtros.id_crm_funil"
    }
  })], 1)], 1), _vm.activeReport === 'oportunidades' ? _c('b-col', {
    attrs: {
      "md": "4",
      "lg": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Etapa"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.etapaOptions
    },
    model: {
      value: _vm.filtros.id_crm_etapa,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "id_crm_etapa", $$v);
      },
      expression: "filtros.id_crm_etapa"
    }
  })], 1)], 1) : _vm._e(), _vm.activeReport === 'oportunidades' ? _c('b-col', {
    attrs: {
      "md": "4",
      "lg": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Temperatura"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.temperaturaOptions
    },
    model: {
      value: _vm.filtros.temperatura,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "temperatura", $$v);
      },
      expression: "filtros.temperatura"
    }
  })], 1)], 1) : _vm._e(), _vm.activeReport === 'oportunidades' ? _c('b-col', {
    attrs: {
      "md": "4",
      "lg": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Fonte"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.fonteOptions
    },
    model: {
      value: _vm.filtros.id_crm_fonte,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "id_crm_fonte", $$v);
      },
      expression: "filtros.id_crm_fonte"
    }
  })], 1)], 1) : _vm._e(), _vm.activeReport === 'oportunidades' ? _c('b-col', {
    attrs: {
      "md": "8",
      "lg": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Buscar nas notas"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Palavras anotadas na timeline"
    },
    model: {
      value: _vm.filtros.busca_notas,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "busca_notas", $$v);
      },
      expression: "filtros.busca_notas"
    }
  })], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm.activeReport === 'tarefas' ? _c('b-row', [_c('b-col', {
    attrs: {
      "md": "4",
      "lg": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Tipo"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.tipoOptions
    },
    model: {
      value: _vm.filtros.tipo,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "tipo", $$v);
      },
      expression: "filtros.tipo"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4",
      "lg": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Vencimento"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.periodoTarefaOptions
    },
    model: {
      value: _vm.filtros.periodo,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "periodo", $$v);
      },
      expression: "filtros.periodo"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm.activeReport === 'agenda' ? _c('b-row', [_c('b-col', {
    attrs: {
      "md": "4",
      "lg": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Tipo"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.tipoOptions
    },
    model: {
      value: _vm.filtros.tipo,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "tipo", $$v);
      },
      expression: "filtros.tipo"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4",
      "lg": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Origem"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.origemAgendaOptions
    },
    model: {
      value: _vm.filtros.origem_agenda,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "origem_agenda", $$v);
      },
      expression: "filtros.origem_agenda"
    }
  })], 1)], 1)], 1) : _vm._e(), _c('div', {
    staticClass: "crm-filter-actions"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "type": "button",
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.aplicarFiltros
    }
  }, [_vm._v(" Aplicar filtros ")]), _c('button', {
    staticClass: "btn btn-light btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.limparFiltros
    }
  }, [_vm._v(" Limpar ")])])], 1)]), _vm.loading ? _c('div', {
    staticClass: "crm-empty-state mb-5"
  }, [_vm._v(" Carregando relatórios... ")]) : _vm._e(), _vm.activeReport === 'resumo' ? [_vm.drillDownLabel ? _c('div', {
    staticClass: "crm-drill-banner"
  }, [_c('span', [_vm._v(_vm._s(_vm.drillDownLabel))]), _c('button', {
    staticClass: "btn btn-light btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.limparDrillDown
    }
  }, [_vm._v(" Limpar seleção ")])]) : _vm._e(), _c('b-row', [_c('b-col', {
    attrs: {
      "xl": "8"
    }
  }, [_c('report-card', {
    attrs: {
      "title": "Funil por etapa"
    }
  }, [_vm.funnelVisualItems.length ? _c('div', {
    staticClass: "crm-funnel-panel"
  }, [_c('div', {
    staticClass: "crm-funnel-summary"
  }, [_c('div', [_c('span', [_vm._v("Oportunidades")]), _c('strong', [_vm._v(_vm._s(_vm.funnelTotalOportunidades))])]), _c('div', [_c('span', [_vm._v("Valor no funil")]), _c('strong', [_vm._v(_vm._s(_vm.formatMoney(_vm.funnelValorTotal)))])]), _c('div', [_c('span', [_vm._v("Maior etapa")]), _c('strong', [_vm._v(_vm._s(_vm.funnelMaiorEtapa))])])]), _c('apexchart', {
    attrs: {
      "type": "bar",
      "height": "360",
      "options": _vm.funnelChartOptions,
      "series": _vm.funnelChartSeries
    }
  })], 1) : _c('div', {
    staticClass: "crm-empty-state"
  }, [_vm._v(" Nenhuma oportunidade encontrada para montar o funil. ")])])], 1), _c('b-col', {
    attrs: {
      "xl": "4"
    }
  }, [_c('report-card', {
    attrs: {
      "title": "Conversão por status"
    }
  }, [_vm.statusConversao.length ? _c('apexchart', {
    attrs: {
      "type": "donut",
      "height": "300",
      "options": _vm.statusChartOptions,
      "series": _vm.statusChartSeries
    }
  }) : _c('div', {
    staticClass: "crm-empty-state"
  }, [_vm._v(" Nenhum status encontrado nos filtros atuais. ")])], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "xl": "8"
    }
  }, [_c('report-card', {
    attrs: {
      "title": "Evolução de oportunidades"
    }
  }, [_vm.evolucaoOportunidades.length ? _c('apexchart', {
    attrs: {
      "type": "area",
      "height": "300",
      "options": _vm.evolucaoChartOptions,
      "series": _vm.evolucaoChartSeries
    }
  }) : _c('div', {
    staticClass: "crm-empty-state"
  }, [_vm._v(" Nenhuma evolução encontrada para o período. ")])], 1)], 1), _c('b-col', {
    attrs: {
      "xl": "4"
    }
  }, [_c('report-card', {
    attrs: {
      "title": "Temperatura"
    }
  }, [_vm.temperaturasResumo.length ? _c('apexchart', {
    attrs: {
      "type": "donut",
      "height": "300",
      "options": _vm.temperaturaChartOptions,
      "series": _vm.temperaturaChartSeries
    }
  }) : _c('div', {
    staticClass: "crm-empty-state"
  }, [_vm._v(" Nenhuma temperatura encontrada nos filtros atuais. ")])], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "lg": "6"
    }
  }, [_c('report-card', {
    attrs: {
      "title": "Ranking de vendedores ganhos"
    }
  }, [_vm.rankingResponsaveis.length ? _c('apexchart', {
    attrs: {
      "type": "bar",
      "height": "320",
      "options": _vm.rankingChartOptions,
      "series": _vm.rankingChartSeries
    }
  }) : _c('div', {
    staticClass: "crm-empty-state"
  }, [_vm._v(" Nenhum responsável com movimento no período. ")])], 1)], 1), _c('b-col', {
    attrs: {
      "lg": "6"
    }
  }, [_c('report-card', {
    attrs: {
      "title": "Motivos de perda"
    }
  }, [_vm.perdasResumo.length ? _c('apexchart', {
    attrs: {
      "type": "bar",
      "height": "320",
      "options": _vm.perdasChartOptions,
      "series": _vm.perdasChartSeries
    }
  }) : _c('div', {
    staticClass: "crm-empty-state"
  }, [_vm._v(" Nenhuma perda registrada para o período atual. ")])], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('report-card', {
    attrs: {
      "title": "Valores por etapa comercial"
    }
  }, [_vm.pipelineValoresItems.length ? _c('apexchart', {
    attrs: {
      "type": "bar",
      "height": "300",
      "options": _vm.pipelineValoresChartOptions,
      "series": _vm.pipelineValoresChartSeries
    }
  }) : _c('div', {
    staticClass: "crm-empty-state"
  }, [_vm._v(" Nenhum valor comercial encontrado para o período. ")])], 1)], 1)], 1), _c('report-card', {
    attrs: {
      "title": "Detalhe das oportunidades"
    }
  }, [_c('div', {
    staticClass: "crm-table-meta"
  }, [_vm._v(" " + _vm._s(_vm.paginacao.oportunidades.total || _vm.oportunidades.length) + " registro(s) "), _vm.drillDownLabel ? _c('span', [_vm._v("· " + _vm._s(_vm.drillDownLabel))]) : _vm._e()]), _c('oportunidades-table', {
    attrs: {
      "items": _vm.oportunidades,
      "format-money": _vm.formatMoney,
      "format-date-time": _vm.formatDateTime,
      "status-label": _vm.statusLabel,
      "valor-oportunidade": _vm.valorOportunidade
    }
  }), _vm.shouldShowPagination('oportunidades') ? _c('div', {
    staticClass: "crm-pagination"
  }, [_c('b-pagination', {
    attrs: {
      "total-rows": _vm.paginacao.oportunidades.total || 0,
      "per-page": _vm.paginacao.oportunidades.per_page || _vm.OPORTUNIDADES_PER_PAGE,
      "align": "right",
      "size": "sm"
    },
    on: {
      "change": function change($event) {
        return _vm.changePage('oportunidades', $event);
      }
    },
    model: {
      value: _vm.paginas.oportunidades,
      callback: function callback($$v) {
        _vm.$set(_vm.paginas, "oportunidades", $$v);
      },
      expression: "paginas.oportunidades"
    }
  })], 1) : _vm._e()], 1)] : _vm._e(), _vm.activeReport === 'oportunidades' ? _c('report-card', {
    attrs: {
      "title": "Oportunidades"
    }
  }, [_c('div', {
    staticClass: "crm-table-meta"
  }, [_vm._v(" " + _vm._s(_vm.paginacao.oportunidades.total || _vm.oportunidades.length) + " registro(s) ")]), _c('oportunidades-table', {
    attrs: {
      "items": _vm.oportunidades,
      "format-money": _vm.formatMoney,
      "format-date-time": _vm.formatDateTime,
      "status-label": _vm.statusLabel,
      "valor-oportunidade": _vm.valorOportunidade
    }
  }), _vm.shouldShowPagination('oportunidades') ? _c('div', {
    staticClass: "crm-pagination"
  }, [_c('b-pagination', {
    attrs: {
      "total-rows": _vm.paginacao.oportunidades.total || 0,
      "per-page": _vm.paginacao.oportunidades.per_page || _vm.OPORTUNIDADES_PER_PAGE,
      "align": "right",
      "size": "sm"
    },
    on: {
      "change": function change($event) {
        return _vm.changePage('oportunidades', $event);
      }
    },
    model: {
      value: _vm.paginas.oportunidades,
      callback: function callback($$v) {
        _vm.$set(_vm.paginas, "oportunidades", $$v);
      },
      expression: "paginas.oportunidades"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm.activeReport === 'clientes' ? _c('report-card', {
    attrs: {
      "title": "Clientes"
    }
  }, [_c('div', {
    staticClass: "crm-table-meta"
  }, [_vm._v(" " + _vm._s(_vm.paginacao.clientes.total || _vm.clientes.length) + " registro(s) ")]), _c('crm-contato-table', {
    attrs: {
      "items": _vm.clientes
    }
  })], 1) : _vm._e(), _vm.activeReport === 'contatos' ? _c('report-card', {
    attrs: {
      "title": "Contatos"
    }
  }, [_c('div', {
    staticClass: "crm-table-meta"
  }, [_vm._v(" " + _vm._s(_vm.paginacao.contatos.total || _vm.contatos.length) + " registro(s) ")]), _c('crm-contato-table', {
    attrs: {
      "items": _vm.contatos
    }
  })], 1) : _vm._e(), _vm.activeReport === 'tarefas' ? _c('report-card', {
    attrs: {
      "title": "Tarefas"
    }
  }, [_c('div', {
    staticClass: "crm-table-meta"
  }, [_vm._v(" " + _vm._s(_vm.paginacao.tarefas.total || _vm.tarefas.length) + " registro(s) ")]), _c('div', {
    staticClass: "crm-report-table"
  }, [_c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("Título")]), _c('th', [_vm._v("Tipo")]), _c('th', [_vm._v("Oportunidade")]), _c('th', [_vm._v("Contato")]), _c('th', [_vm._v("Responsável")]), _c('th', [_vm._v("Status")]), _c('th', [_vm._v("Vencimento")])])]), _c('tbody', [_vm._l(_vm.tarefas, function (item) {
    return _c('tr', {
      key: item.id_crm_atividade
    }, [_c('td', [_vm._v(_vm._s(item.titulo))]), _c('td', [_vm._v(_vm._s(_vm.tipoLabel(item.tipo)))]), _c('td', [_vm._v(_vm._s(item.oportunidade || "-"))]), _c('td', [_vm._v(_vm._s(item.contato || "-"))]), _c('td', [_vm._v(_vm._s(item.usuario || "-"))]), _c('td', [_vm._v(_vm._s(_vm.statusAtividadeLabel(item.status)))]), _c('td', [_vm._v(_vm._s(_vm.formatDateTime(item.vencimento_em)))])]);
  }), !_vm.tarefas.length ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("Nenhuma tarefa encontrada.")])]) : _vm._e()], 2)])])]) : _vm._e(), _vm.activeReport === 'agenda' ? [_vm.filtros.origem_agenda !== 'solicitacoes' ? _c('report-card', {
    attrs: {
      "title": "Agenda CRM"
    }
  }, [_c('div', {
    staticClass: "crm-table-meta"
  }, [_vm._v(" " + _vm._s(_vm.paginacao.agenda.total || _vm.agenda.length) + " registro(s) ")]), _c('div', {
    staticClass: "crm-report-table"
  }, [_c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("Título")]), _c('th', [_vm._v("Contato")]), _c('th', [_vm._v("Oportunidade")]), _c('th', [_vm._v("Responsável")]), _c('th', [_vm._v("Status")]), _c('th', [_vm._v("Início")])])]), _c('tbody', [_vm._l(_vm.agenda, function (item) {
    return _c('tr', {
      key: item.id_crm_agenda
    }, [_c('td', [_vm._v(_vm._s(item.titulo))]), _c('td', [_vm._v(_vm._s(item.contato || "-"))]), _c('td', [_vm._v(_vm._s(item.oportunidade || "-"))]), _c('td', [_vm._v(_vm._s(item.usuario || "-"))]), _c('td', [_vm._v(_vm._s(_vm.statusAgendaLabel(item.status)))]), _c('td', [_vm._v(_vm._s(_vm.formatDateTime(item.data_inicio)))])]);
  }), !_vm.agenda.length ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("Nenhum compromisso CRM encontrado.")])]) : _vm._e()], 2)])])]) : _vm._e(), _vm.filtros.origem_agenda !== 'agenda' ? _c('report-card', {
    attrs: {
      "title": "Solicitações de agenda técnica"
    }
  }, [_c('div', {
    staticClass: "crm-table-meta"
  }, [_vm._v(" " + _vm._s(_vm.paginacao.solicitacoes.total || _vm.solicitacoes.length) + " registro(s) ")]), _c('div', {
    staticClass: "crm-report-table"
  }, [_c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("Oportunidade")]), _c('th', [_vm._v("Contato")]), _c('th', [_vm._v("Vendedor")]), _c('th', [_vm._v("Técnico")]), _c('th', [_vm._v("Status")]), _c('th', [_vm._v("Agendamento")])])]), _c('tbody', [_vm._l(_vm.solicitacoes, function (item) {
    return _c('tr', {
      key: item.id_crm_solicitacao_tecnica
    }, [_c('td', [_vm._v(_vm._s(item.oportunidade || "-"))]), _c('td', [_vm._v(_vm._s(item.contato || "-"))]), _c('td', [_vm._v(_vm._s(item.vendedor || "-"))]), _c('td', [_vm._v(_vm._s(item.tecnico || "-"))]), _c('td', [_vm._v(_vm._s(_vm.statusSolicitacaoLabel(item.status)))]), _c('td', [_vm._v(_vm._s(_vm.formatDateTime(item.agenda_data_inicio)))])]);
  }), !_vm.solicitacoes.length ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("Nenhuma solicitação técnica encontrada.")])]) : _vm._e()], 2)])])]) : _vm._e()] : _vm._e()], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };